// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"9b69d54d","652":"e0f77485","685":"058adb78","829":"c77dec34"}[chunkId] + ".chunk.js";
};